// extracted by mini-css-extract-plugin
export default {"heavyText":"HeavyText_heavyText__CJEwI","smallSize":"HeavyText_smallSize__poTUj","circle":"HeavyText_circle__50b+e"};